// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.config-popup {
  display: block;
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/customizer/customizer.component.scss","webpack://./../contandoui2.0%20-%20TP/src/app/shared/components/customizer/customizer.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;ACCJ","sourcesContent":[".config-popup {\n    display: block;\n    border-bottom: none;\n}",".config-popup {\n  display: block;\n  border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
